module.exports = __webpack_public_path__ + "img/Portugal Logo 2nd.f9460797.jpg";